import { enStatus, ICourse } from 'interface/course';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';

import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  root: {
    '& h3, p, b': {
      color: theme.variables.courseTheme.text,
    },
    '& b': {
      fontweight: 700,
    },
    margin: theme.spacing(4, 0),
    display: 'flex',
    borderRadius: 8,
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(6),
    background: theme.variables.courseTheme.cardBackground,
  },
  textButton: {
    '&:hover': {
      color: theme.palette.info.main,
    },
    color: theme.palette.info.dark,
    fontWeight: 600,
    cursor: 'pointer',
  },
}));

const BlockedBySomeone = () => {
  const classes = useStyles();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const courseStatus = useAppSelector((state) => state.course.status);
  const producer = useAppSelector((state) => state.course.producer as ICourse['producer']);

  if (isAuthenticated && courseStatus === enStatus.FREE) {
    return null;
  }

  const openPaymentFaq = () => {
    window.open(
      'https://ajuda.eduzz.com/hc/pt-br/articles/1260806909249-Como-alterar-a-forma-de-pagamento-de-uma-assinatura-',
      '_blank'
    );
  };

  return (
    <div className={classes.root}>
      <Typography variant='h3' component='b'>
        Seu curso foi bloqueado, siga as orientações abaixo:
      </Typography>
      <Box marginTop={4}>
        <Typography variant='body1' component='p'>
          Verifique se seus dados de pagamento precisam ser atualizados para continuar acessando esse curso,{' '}
          <span onClick={openPaymentFaq} className={classes.textButton}>
            clique aqui
          </span>{' '}
          e siga as orientações.
        </Typography>
      </Box>
      <Box marginTop={1}>
        <Typography variant='body1' component='b'>
          Se está tudo certo com os seus dados de pagamento, entre em contato com o seu Produtor para saber mais.
        </Typography>
      </Box>
      <Box marginTop={1}>
        <Typography variant='body1' component='p'>
          <b>Produtor</b>: {producer.name}
        </Typography>
        <Typography variant='body1' component='p'>
          <b>E-mail</b>: {producer.email}
        </Typography>
      </Box>
    </div>
  );
};

export default BlockedBySomeone;
